<template>
  <a-modal
    v-model:visible="visible"
    :mask-closable="false"
    :keyboard="false"
    :destroy-on-close="true"
    :closable="false"
    centered
    width="1200px"
    :footer="null"
    :title="`Editar perfil - ${record?.name}`"
  >
    <div class="container">
      <CloseOutlined class="iconoCerrado" @click="handleCloseModal" />
      <profile-form-edit
        @emitEdit="handleClose"
        @onConfirmationModal="showConfirmationModal = true"
      />
    </div>
  </a-modal>
</template>

<script>
import ProfileFormEdit from "@/app/users/components/form/ProfileFormEdit.vue";
import { CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, createVNode } from "vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    ProfileFormEdit,
    CloseOutlined,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showConfirmationModal: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set() {
        this.$emit("onClose");
      },
    },
    record() {
      return this.$store.getters["getProfile"];
    },
  },
  methods: {
    handleCloseModal() {
      if (this.showConfirmationModal) {
        this.handleConfirmationClose();
      } else {
        this.handleClose();
      }
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
        width: 450,
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleClose(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    handleClose() {
      this.showConfirmationModal = false;
      this.visible = false;
      this.$emit("onClose");
    },
  },
});
</script>

<style lang="sass" scoped>
.iconoCerrado
  position: absolute
  top: 22px
  right: 16px
.container
  padding: 20px
.footer
    position: absolute
    left: 0
    bottom: 0
    width: 972px
    height: 56px
    display: flex
    align-items: center
    justify-content: flex-end
    border-top: 1px solid $gray-5
    &__next
      margin-right: 1rem
    &__back
      margin-right: 1rem
</style>
